export const experienceData = [
    {
        id: 1,
        company: 'SwiftPim Products Pvt. Ltd. (Richpanel)',
        jobtitle: 'Technical Support Engineer',
        startYear: '2021',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Softcell Technology Pvt. Ltd.',
        jobtitle: 'Technical Support Engineer',
        startYear: '2018',
        endYear: '2021'
    }
]